export abstract class OverlayCoreDSL {

  // 默认浮层名称
  public defaultName = "DefaultOverlay";

  // 展示浮层
  abstract showOverlay(data: any): void

  // 隐藏浮层
  abstract hideOverlay(): void
}